import React, { useState, useEffect } from 'react';
import { ArrowUp } from '@phosphor-icons/react';
import { motion, AnimatePresence } from '@/lib/motion';

export const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-36 sm:bottom-44 right-6 z-40 w-12 h-12 bg-obsidian text-white flex items-center justify-center hover:bg-bronze hover:text-obsidian transition-colors duration-300 shadow-lg"
          aria-label="Scroll to top"
          data-testid="scroll-to-top"
        >
          <ArrowUp weight="bold" className="w-5 h-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
